import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/copy.svg';

export const IconCopy = createIconComponent(Icon);
